<script>
	import Copy from "../../icons/Copy.svelte";
	import Edit from "../../icons/Edit.svelte";
	import Ellipsis from "../../icons/Ellipsis.svelte";
	import Trash from "../../icons/Trash.svelte";
	import { fly } from "svelte/transition";
	import { navigate } from "svelte-navigator";
	import CopyToClipboardButton from "../../general/CopyToClipboardButton.svelte";
	import { delete_recipe } from "../../tastummy";
	import { createEventDispatcher } from "svelte/internal";
	import { clickOutside } from "../../general/click_outside";

	export let recipe_id;
	let visible = false;
	const dispatch = createEventDispatcher();

	function button_delete(id) {
		delete_recipe(id).then(() => {
			dispatch("removed", {});
		});
	}
</script>

<div
	on:outclick={() => (visible = false)}
	use:clickOutside
	class="dropdown-holder"
>
	<button
		class="dropdown-icon"
		class:visible
		on:click|stopPropagation={() => (visible = !visible)}
		><Ellipsis /></button
	>
	{#if visible}
		<div
			on:click|stopPropagation={() =>
				navigate(`/recipe/${recipe_id}/edit`)}
			transition:fly={{ x: 80, duration: 500 }}
			class="edit icon"
		>
			<Edit />
		</div>
		<div transition:fly={{ x: 80, y: 80, duration: 500 }} class="copy icon">
			<CopyToClipboardButton
				style="padding: 0px"
				copy_value="{window.location.href}/{recipe_id}/import"
			>
				<Copy />
			</CopyToClipboardButton>
		</div>
		<div
			on:click|stopPropagation={() => button_delete(recipe_id)}
			transition:fly={{ y: 80, duration: 500 }}
			class="delete icon"
		>
			<Trash />
		</div>
	{/if}
</div>

<style>
	.dropdown-icon {
		padding: 8px;
		height: 100%;
		margin-bottom: 0px;
		border-radius: 30px;
	}
	.dropdown-icon.visible {
		background: var(--button-secondary);
	}
	.dropdown-holder {
		position: relative;
	}
	.icon {
		background: var(--button);
		color: black;
		border-radius: 30px;
		padding: 1rem;
	}
	.edit {
		position: absolute;
		left: -6rem;
		top: -0.5rem;
	}
	.copy {
		position: absolute;
		left: -5rem;
		top: -5rem;
	}
	.delete {
		position: absolute;
		top: -6rem;
		left: -0.5rem;
		background: var(--red);
	}
</style>
